import { zfTranslations } from "./zf_translations";
import { zfUtils } from "./zf_utils";
import { zfc } from "./zfc_global";
export class zfctm {
    static calcFontSize(num) {
        if ($(window).outerWidth() > 1024) {
            return zfctm.baseFontSize - Math.floor(num.toString().length / 3) * 8;
        }
        else {
            return zfctm.mobileFontSize - Math.floor(num.toString().length / 3) * 8;
        }
    }
    static numberFormat(num, decimals, thousands_sep, dec_point) {
        var parts = num.toFixed(decimals).split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_sep);
        return parts.join(dec_point);
    }
    static decimalPlaces(num, dec_point) {
        return num.indexOf(dec_point) == -1
            ? 0
            : num.length - num.indexOf(dec_point) - 1;
    }
    static initItem(item) {
        try {
            item.find("img[data-src]").each(function () {
                $(this).attr("src", $(this).data("src"));
            });
            if (item.find(".delayZFCFSVPreInit") && item.closest(".zfcui-modal").length > 0) {
                zfUtils.checkLoadOnScroll();
            }
            if (item.find("table").length > 0) {
                item.addClass("zfctm-text-media-table");
            }
            item
                .find(".zfctm-show-more-link-tag")
                .off("click.zfctm")
                .on("click.zfctm", function () {
                var that = $(this);
                if ($(".zfcui-modal").find(".zfctm-show-more-link-tag").length > 0)
                    that.parent().toggleClass("zfc-show-more-toggled");
                if (that.parent().hasClass("zfc-show-more-toggled")) {
                    that
                        .find(".zfc-show-more-link-text")
                        .text(zfTranslations.get("show_less"));
                }
                else {
                    that
                        .find(".zfc-show-more-link-text")
                        .text(zfTranslations.get("show_more"));
                }
                that.parent().parent().find(".zfctm-show-more-copy-text").slideToggle();
            });
            item.find(".zfctm-count-number").each(function () {
                var that = $(this), numberVal = that.text(), currentNumber, seperatorType = that.data("separator"), decimalType = that.data("decimal"), languageType = that.data("lang"), numDecimals = zfctm.decimalPlaces(numberVal, decimalType);
                numberVal = parseFloat(languageType == "DE"
                    ? numberVal.replace(RegExp(decimalType, "g"), ".")
                    : numberVal).toFixed(numDecimals);
                var customUnit = that
                    .parent()
                    .find(".zfctm-count-number-custom-unit")
                    .text();
                var fontSize;
                if (that.parent().hasClass(".zfctm-text-media-number-percent")) {
                    fontSize = zfctm.calcFontSize(Math.round(parseFloat(parseFloat(numberVal.replace(RegExp(seperatorType, "g"), "")).toFixed(numDecimals))) + customUnit);
                }
                else {
                    fontSize = zfctm.calcFontSize(Math.round(parseFloat(parseFloat(numberVal.replace(RegExp(seperatorType, "g"), "")).toFixed(numDecimals))));
                }
                that.text(1);
                that.parent().css({
                    fontSize: fontSize,
                });
                that.init = function () {
                    that.prop("counter", 0).animate({
                        counter: numberVal,
                    }, {
                        duration: zfctm.duration,
                        step: function (now) {
                            currentNumber = zfctm.numberFormat(now, numDecimals, seperatorType, decimalType);
                            that.text(currentNumber);
                        },
                    });
                };
                that.init();
            });
            return true;
        }
        catch (err) {
            console.log("Initalization failed: zfctm.initItem() " + err.message);
        }
    }
    static init() {
        try {
            zfc.modalCallbacks[".zfctm-text-media"] = zfctm.initItem;
            $(".zfctm-text-media").each(function () {
                $(this)
                    .find('[data-wrapper="true"]')
                    .attr("style", "")
                    .find("[style]")
                    .attr("style", "");
                zfUtils.loadOnScroll($(this), "delayZFCTMLoad", zfctm.initItem, 1);
            });
        }
        catch (err) {
            console.log("Initalization failed: zfctm.init() " + err.message);
        }
    }
}
zfctm.baseFontSize = 108;
zfctm.mobileFontSize = 75;
zfctm.duration = 2000;
try {
    zfUtils.onReady(zfctm.init);
}
catch (err) {
    console.log("Initalization failed: zfctm.init() " + err.message);
}
